/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input, OnInit } from '@angular/core';
import { ChartConfiguration } from 'chart.js';

@Component({
  selector: 'ptl-daily-views-chart',
  templateUrl: './daily-views-chart.component.html',
  styleUrls: ['../common-analytics-chart-styles.scss', './daily-views-chart.component.scss'],
})
export class DailyViewsChartComponent implements OnInit {
  @Input() dailyViewCounts: { [p: string]: number };
  @Input() uniqueViewers: number;
  @Input() totalViews: number;

  lineChartData: ChartConfiguration['data'];
  lineChartOptions: ChartConfiguration['options'];

  ngOnInit(): void {
    this.prepareChartData();
  }

  get peakViewDay(): string | null {
    if (!this.dailyViewCounts || Object.keys(this.dailyViewCounts).length === 0) {
      return null;
    }

    const maxViews = Math.max(...Object.values(this.dailyViewCounts));
    const peakDate = Object.keys(this.dailyViewCounts).find((date) => this.dailyViewCounts[date] === maxViews);

    return new Date(peakDate).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
  }

  get avgViewsPerUser(): string {
    if (this.uniqueViewers === 0) return '0';
    return (this.totalViews / this.uniqueViewers).toFixed(1);
  }

  private prepareChartData(): void {
    const sortedDates = Object.keys(this.dailyViewCounts).sort();
    const labels = sortedDates.map((date) => new Date(date).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }));
    const data = sortedDates.map((date) => this.dailyViewCounts[date]);

    this.lineChartData = {
      labels,
      datasets: [
        {
          label: '',
          data,
          borderColor: '#4A90E2',
          backgroundColor: 'rgba(74, 144, 226, 0.1)',
          fill: true,
          tension: 0,
          pointStyle: 'false',
          pointRadius: 0,
          pointHoverRadius: 4,
          datalabels: {
            display: false,
          },
        },
      ],
    };

    this.lineChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
          text: 'Playlist Views Over Time',
          font: {
            size: 16,
            weight: 'bold',
          },
        },
        tooltip: {
          mode: 'index',
          intersect: false,
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 1,
          },
          title: {
            display: false,
            text: 'Views',
          },
        },
        x: {
          title: {
            display: false,
            text: 'Timeline',
          },
          grid: {
            display: false,
          },
          ticks: {
            font: { family: 'Arial', size: 12 },
            color: '#333',
          },
        },
      },
    };
  }
}
